import axiosInstance from '@/utils/axiosInstance'
import { store } from '@/store'

/**
 * API call wrapper with integrated error handling and toast notifications.
 *
 * Usage:
 *   const { data, error } = await api.post('/airdrop/list', { offset: 0, limit: 10 })
 *   if (error) return
 *   // use data
 *
 * @param {string} method - HTTP method (get, post, put, delete)
 * @param {string} url - API endpoint
 * @param {object} payload - Request body (for post/put)
 * @param {object} options - { silent: boolean, successMsg: string }
 */
async function request(method, url, payload, options = {}) {
  try {
    const response =
      method === 'get' || method === 'delete'
        ? await axiosInstance[method](url, { params: payload })
        : await axiosInstance[method](url, payload)

    if (options.successMsg) {
      store.dispatch('toast/success', options.successMsg)
    }

    return { data: response.data, status: response.status, error: null }
  } catch (err) {
    if (!options.silent) {
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        'An unexpected error occurred'
      store.dispatch('toast/error', msg)
    }
    return {
      data: null,
      status: err?.response?.status || 0,
      error: err,
    }
  }
}

export default {
  get: (url, params, options) => request('get', url, params, options),
  post: (url, data, options) => request('post', url, data, options),
  put: (url, data, options) => request('put', url, data, options),
  delete: (url, params, options) => request('delete', url, params, options),
}
